import { useCallback, useMemo, useState } from 'react';

export const useTasksTabControls = () => {
  const [checkedItems, setCheckedItems] = useState<number[]>([]);
  const [pageIds, setPageIds] = useState<number[]>([]);
  const [countOnPage, setCountOnPage] = useState(0);
  const [taskCreateOpen, setTaskCreateOpen] = useState(false);

  const handleToggleAll = useCallback(
    (checked: boolean) => {
      setCheckedItems((prev) =>
        checked ? Array.from(new Set([...prev, ...pageIds])) : prev.filter((id) => !pageIds.includes(id)),
      );
    },
    [pageIds],
  );

  const isAllChecked = useMemo(() => pageIds.length > 0 && pageIds.every((id) => checkedItems.includes(id)), [pageIds, checkedItems]);
  const isIndeterminate = useMemo(() => !isAllChecked && pageIds.some((id) => checkedItems.includes(id)), [isAllChecked, pageIds, checkedItems]);

  const openTaskCreateDialog = useCallback(() => setTaskCreateOpen(true), []);
  const closeTaskCreateDialog = useCallback(() => setTaskCreateOpen(false), []);

  return {
    checkedItems,
    setCheckedItems,
    pageIds,
    setPageIds,
    countOnPage,
    setCountOnPage,
    handleToggleAll,
    isAllChecked,
    isIndeterminate,
    taskCreateOpen,
    openTaskCreateDialog,
    closeTaskCreateDialog,
  };
};
